import { useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { FaEnvelope } from 'react-icons/fa';
import { FaPhone } from 'react-icons/fa6';
import { IoLogoWhatsapp } from 'react-icons/io';
import { MdError } from "react-icons/md";
import { TiLocation } from "react-icons/ti";

const Contact = ({ ref }) => {
    const [fullname, setFullname] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [subjectError, setSubjectError] = useState(false);
    const [messageError, setMessageError] = useState(false);

    const sanitize = data => {
        if (data === '' || null) {
            return '';
        }
        return data = data.trim().replace(/<[^>]*>/g, '')
    }

    const validateName = () => {
        let data = sanitize(fullname);
        if (data === '' || null) {
            setNameError(true);
            return ''
        }
        if (data.length > 4 && data.length < 41 && !data.match(/\d/g)) {
            setNameError(false);
        } else {
            setNameError(true);
        }
    }

    const validateEmail = () => {
        let data = sanitize(email.toString().toLowerCase());
        if (data === '' || null) {
            setEmailError(true);
            return ''
        }

        let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (data.match(mailFormat)) {
            setEmailError(false);
            setEmail(data);
        } else {
            setEmailError(true);
        }
    }

    const validateSubject = () => {
        let data = sanitize(subject);
        if (data === '' || null) {
            setSubjectError(true);
            return ''
        }
        if (data.length > 5 && data.length < 41) {
            setSubjectError(false);
        } else {
            setSubjectError(true);
        }
    }

    const validateMessage = () => {
        let data = sanitize(message);
        if (data === '' || null) {
            setMessageError(true);
            return ''
        }
        if (data.length > 20 && data.length < 200) {
            setMessageError(false);
        } else {
            setMessageError(true);
        }
    }

    const sendMessage = async (e) => {
        e.preventDefault();
        if ((nameError || emailError || subjectError || messageError) ||
            (fullname === '' || email === '' || subject === '' || message === '')
        ) {
            return Swal.fire({
                icon: "error",
                title: "Please fill the form correctly!",
                confirmButtonColor: "red",
            });
        }

        await axios.post('https://formspree.io/f/mleqwvrn?', {
            "Full Name": fullname,
            "Email": email,
            "Subject": subject,
            "Message": message
        }).then(() => {
            setFullname('');
            setEmail('');
            setSubject('');
            setMessage('');
            Swal.fire({
                icon: "success",
                title: "THANKS😍 for your FEEDBACK!!! We will get back to YOU soon.",
                confirmButtonColor: "teal",
            })
        }).catch((error) => {
            Swal.fire({
                icon: "error",
                title: error.message,
                confirmButtonColor: "red",
            })
        })
    }







    return (
        <>
            <section id="contact">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="wow bounceIn">
                                <h2 className="wow bounceIn text-uppercase">Contact</h2>
                                <hr />
                                <h4 className="contact-style">To book our services or make further inquires, please give us a call or send us a message...</h4>

                                <div className='contact-address-div'>
                                    <TiLocation size={30} color='#55ACEE' />
                                    <span style={{ fontSize: 18, marginLeft: 5 }}>
                                        5th Floor, Residential Wing, Mukhtar El-Yakub Place, Central Business District, Abuja - Nigeria
                                    </span>
                                </div>

                                <div className='contact-icons-div'>
                                    <div className='contact-icons'><FaPhone size={20} color='#55ACEE' /> <span style={{ fontSize: 18, marginLeft: 5 }}>+2348036940709</span></div>
                                    <div className='contact-icons'><IoLogoWhatsapp size={20} color='#55ACEE' /> <span style={{ fontSize: 18, marginLeft: 5 }}>+2348077014077</span></div>
                                    <div className='contact-icons'><FaEnvelope size={20} color='#55ACEE' /> <span style={{ fontSize: 18, marginLeft: 5 }}>mail.brainytech@gmail.com</span></div>
                                </div>
                            </div>
                            <form >
                                <div className="col-md-4 col-sm-4 wow fadeIn" data-wow-delay="0.3s">
                                    <input
                                        type="text"
                                        name="fullname"
                                        placeholder="Full Name"
                                        className="form-control"
                                        minLength="5"
                                        maxLength="40"
                                        required
                                        value={fullname}
                                        onChange={e => setFullname(e.target.value)}
                                        onBlur={validateName}
                                    />
                                    {nameError && (
                                        <div className='error-container'>
                                            <MdError className="error-icon" />
                                            <span className='error'>Please enter 5 or more characters</span>
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-4 col-sm-4 wow fadeIn" data-wow-delay="0.3s">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email"
                                        className="form-control"
                                        maxLength="30"
                                        required
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        onBlur={validateEmail}
                                    />
                                    {emailError && (
                                        <div className='error-container'>
                                            <MdError className="error-icon" />
                                            <span className='error'>Please enter a valid email</span>
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-4 col-sm-4 wow fadeIn" data-wow-delay="0.3s">
                                    <input
                                        type="text"
                                        name="subject"
                                        placeholder="Subject"
                                        className="form-control"
                                        maxLength="40"
                                        required
                                        value={subject}
                                        onChange={e => setSubject(e.target.value)}
                                        onBlur={validateSubject}
                                    />
                                    {subjectError && (
                                        <div className='error-container'>
                                            <MdError className="error-icon" />
                                            <span className='error'>Please enter a valid subject, which is not more than 40 characters</span>
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-12 col-sm-12 wow fadeIn" data-wow-delay="0.9s">
                                    <textarea
                                        name="message"
                                        className="form-control"
                                        rows="5"
                                        placeholder="Message"
                                        maxLength="200"
                                        required
                                        value={message}
                                        onChange={e => setMessage(e.target.value)}
                                        onBlur={validateMessage}
                                    ></textarea>
                                    {messageError && (
                                        <div className='error-container'>
                                            <MdError className="error-icon" />
                                            <span className='error'>Please enter a valid message which is not more than 200 characters</span>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className="col-md-offset-3 col-sm-offset-3 col-sm-6 col-md-6 wow fadeIn" data-wow-delay="0.3s"
                                    onClick={sendMessage}
                                >
                                    <input type="submit" value="Send Message" className="form-control" />
                                </div>
                            </form>
                        </div>
                    </div >
                </div >
            </section >
        </>
    )
}

export default Contact